const rawBase = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');

export const API_ROOT = `${rawBase}/api/v1`;
export const ADMIN_ROOT = `${rawBase}/api/v1/admin`;

/** Public storefront URL (sidebar link). Defaults to the local dev server. */
export const STORE_URL = import.meta.env.VITE_STORE_URL ?? 'http://localhost:5173';

export function imageUrl(imageKey: string | null): string | null {
  if (!imageKey) return null;
  return `${rawBase}/img/${imageKey}`;
}
